import * as React from "react";
import { Logs } from "./LogsPage";

type Props = {};

const LogsPage = (props: Props) => {
	return <Logs />;
};

export default LogsPage;
